<template>
    <div class="contain">
        <div class="top" >
            <div class="top_cover">
                <span class="cover_text">솔닥 사용 설명서</span>
                 <span class="cover_sub_text">진료에서 처방까지 솔닥 사용법</span>
            </div>
        </div> 
        <div class="navBar">
            <div class="barElement">
                <span>앱 다운로드 없이 카카오톡으로, 쉽고 간편한 솔닥 비대면 진료</span>   
                <div class="button c5_head_btn" @click="gokakao('5-purchse')">
                    진료실 바로가기
                </div>
            </div>
        </div>
        <img class="imgs c5_ibtn1" @click="gokakao('5-purchse')" src="../../../assets/etc_01_btn.jpg" />
        <img class="imgs" src="../../../assets/etc_02.jpg" />
        <img class="imgs" src="../../../assets/etc_03.jpg" />
        <img class="imgs" src="../../../assets/etc_04.jpg" />
        <img class="imgs" src="../../../assets/etc_05.jpg" />
        <img class="imgs" src="../../../assets/etc_06.jpg" />
        <img class="imgs" src="../../../assets/etc_07.jpg" />
        <img class="imgs c5_ibtn2" @click="gokakao('5-purchse')" src="../../../assets/etc_08_btn.jpg" />
        <img @click="gokakao('5-purchse')" class="c5_fbtn" src="../../../assets/f_btn.png" />
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name:'skinhair',
    methods: {
        gokakao: function(eventname)
        {
            this.conversionApi(eventname);
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 96598},

                // To Do 1. 현재 유저의 이메일 주소(공백 제거 및 소문자로 변환 후) 전달. 유저의 이메일을 알수 없는 상황이면 빈 문자열로 전달
                { event: "setEmail", email: "##User Email##" },

                // To Do 2. 현재 유저의 저장된 배송지 우편번호. 유저의 배송지 우편번호를 알수 없는 상황이면 빈 문자열로 전달
                { event: "setZipcode", zipcode: "##Zip Code##" },

                { event: "setSiteType", type: deviceType},

                // To Do 3. 확인 또는 주문 번호를 전달
                // Tip 1. 다른 종류의 전환일 경우 상품 ID에 다른 값으로 전달하여 나중에 리포트를 통해 확인 가능
                { event: "trackTransaction", id: Math.floor(Math.random()*99999999999), item: [
                    {id: "1", price: 1, quantity: 1 }
                ]}
            );

            window.open('https://tele.soldoc.co.kr/booking', '_blank');
        },
        conversionApi: function(eventname)
        {
            const time = Date.now();
            let stime = time.toString().slice(0, 10);
            const data = {
                data: 
                [
                    {
                        event_name: eventname,
                        // text_event_code: "TEST43477",
                        event_time: Number(stime),
                        action_source: "email",
                        user_data: {
                            em: [
                                "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068"
                            ],
                            ph: [
                                null
                            ]
                        },
                        custom_data: {
                            "currency": "USD",
                            "value": "142.52"
                        }
                    }
                ]
            }
            return axios({
                method: 'post',
                url: 'https://graph.facebook.com/v15.0/580521327268842/events?access_token=EAAHIPxRrOeYBAHfdaUR70ZAZA8EamzQKUvK8aqMnrYkvKZALvCbi7C7Etg0n16uhtxUxRZCxAeZCaiWaUTM7yJs4wbkfZC3omvYc14FoImXXN1ciRHtBv2tZB3fCzeRb9ppQR9oP2aGJwqJVNR0btsZCOrhrj9s7KiGv3mnCPPNiOau6kUUG95nchnH5mSdOyBkZD.',
                data: data
            })
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 1200px;
    }
    .navBar{
        width: 100%;
        min-height: 80px;
        max-height: 80px;
        background: #FFFFFF;
        border-bottom: 1px solid #CCCCCC;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background: blue; */
    }
    .barElement{
        width: 1200px;
        min-width: 1200px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        color: #1A1A1A;
    }
    .button{
        width: 174px;
        height: 48px;
        background: #018DDC;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        cursor: pointer;
    }

    .imgs{
        min-width: 2000px;
    }
    .top{
        max-height: 900px;
        min-height: 900px;
        width: 100%;
        /* min-width: 1200px; */
        background: url('../../../assets/etc_top.jpg');
        background-size: cover;
        position: relative;
    }
    .top_cover{
        position: absolute;
        max-height: 900px;
        min-height: 900px;
        width: 100%;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .cover_text{
        color: #ffffff;
        font-family : 'Noto Sans KR';
        font-size: 64px;
        font-weight: 500;
    }
    .cover_sub_text{
        color: #ffffff;
        font-family : 'Noto Sans KR';
        font-size: 22px;
        font-weight: 400;
        margin-top: 20px;
    }
    
    .c5_fbtn{
        position: fixed;
        bottom: 20px;
        right: 10px;
        width: 80px;
        z-index: 10;
        cursor: pointer;
    }
    .c5_ibtn1{
        cursor: pointer;
    }
    .c5_ibtn2{
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/c5.vue